"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
var useInterval = function (callback, delay, additionalDependenciesThatShouldTriggerResettingInterval) {
    if (additionalDependenciesThatShouldTriggerResettingInterval === void 0) { additionalDependenciesThatShouldTriggerResettingInterval = []; }
    var savedCallback = react_1.useRef();
    // Remember the latest callback.
    react_1.useEffect(function () {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the interval.
    react_1.useEffect(function () {
        function tick() {
            var _a;
            (_a = savedCallback.current) === null || _a === void 0 ? void 0 : _a.call(savedCallback);
        }
        if (delay !== null) {
            var id_1 = setInterval(tick, delay);
            return function () { return clearInterval(id_1); };
        }
    }, __spreadArrays([delay], additionalDependenciesThatShouldTriggerResettingInterval));
};
exports.default = useInterval;
